import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import '../App.css';
import Sidebar from '../componenteExtra/SidebarStaff';
import { GrupoContext } from '../GrupoContext';
import SessionManager from '../componenteExtra/SessionManager';

const ActividadesFinalizadasStaff = () => {
    const { grupo: staffName } = useContext(GrupoContext);
    const [actividades, setActividades] = useState([]);
    const [grupoFiltro] = useState('Todos');
    const [nombreGet, setNombreGet] = useState('');

    const token = localStorage.getItem("access_token");

    useEffect(() => {
        // Restaurar el estado de nombreGet desde localStorage
        const savedNombreGet = localStorage.getItem('nombre_get');
        if (savedNombreGet) {
            setNombreGet(savedNombreGet);
        }

        // Cargar actividades si el nombre está disponible
        if (savedNombreGet) {
            fetchActividadesFinalizadas(savedNombreGet);
        }
    }, []);

    useEffect(() => {
        // Guardar el nombre en localStorage si cambia
        if (nombreGet) {
            localStorage.setItem('nombre_get', nombreGet);
        }
    }, [nombreGet]);

    const fetchActividadesFinalizadas = async (nombre) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/finished_activities/${nombre}`, 
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            )
            setActividades(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const actividadesFiltradas = grupoFiltro === 'Todos' ? actividades : actividades.filter(actividad => actividad.numero_grupo === parseInt(grupoFiltro, 10));
    const totalActividades = actividades.length;

    return (
        <div className="app">
            <SessionManager />
            <Sidebar />
            <div className="main-content">
                <div className="main-panel">
                    <h1>Actividades anuladas - {nombreGet}</h1>
                    <h2>Total Actividades: {totalActividades}</h2>
                    <table className="activities-table">
                        <thead>
                            <tr>
                                    <th>Código de Proyecto</th>
                                    <th>Nombre Proyecto</th>
                                    <th>Razón Social</th>
                                    <th>Filial</th>
                                    <th>Tipo de trabajo</th>
                                    <th>Regulación</th>
                                    <th>Socio de auditoría</th>
                                    <th>Rubro GET</th>
                                    <th>Nombre Actividad GET</th>
                                    <th>Staff Asignado</th>
                                    <th>Fecha de Estado Staff</th>
                                    <th>Horas GET</th>
                                    <th>Horas Estándar</th>
                                </tr>
                            </thead>
                            <tbody>
                                  {actividadesFiltradas.map((activity, index) => (
                                    <tr key={index}>
                                        <td>{activity.codigo_proyecto}</td>
                                        <td>{activity.nombre_proyecto}</td>
                                        <td>{activity.razon_social}</td>
                                        <td>{activity.filial}</td>
                                        <td>{activity.tipo_solicitud}</td>
                                        <td>{activity.tipo_regulacion}</td>
                                        <td>{activity.encargado_auditoria}</td>
                                        <td>{activity.rubro_get}</td>
                                        <td>{activity.nombre_actividad_get}</td>
                                        <td>{activity.staff_asignado}</td>
                                        <td>{activity.fecha_estado_staff}</td>
                                        <td>{activity.horas_get}</td>
                                        <td>{activity.horas_estandar}</td>
                                    </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ActividadesFinalizadasStaff;
